export const enum textModalCategory {
  privacyPolicy = 'privacyPolicy',
  teamOfUse = 'teamOfUse',
}

export const getPrivacyPolicy = (locale: 'ja' | 'en') => {
  const fixPrivacyPolicyTextList = PrivacyPolicyTextList
  switch (locale) {
    case 'en':
      fixPrivacyPolicyTextList.subTitle = 'Privacy Policy'
      fixPrivacyPolicyTextList.customButton = { closeButton: { title: 'Close' } }
      break;
    case "ja":
    default:
      fixPrivacyPolicyTextList.subTitle = 'プライバシーポリシー'
      fixPrivacyPolicyTextList.customButton = { closeButton: { title: '閉じる' } }
      break;
  }
  return fixPrivacyPolicyTextList
}

export type useStateTextModalType = {
  textModal: textModalType
  show: boolean
  accept?: () => void
  close?: () => void
}

export type textModalType = {
  title: string
  subTitle: string
  prefaceText?: string
  textList: TextListItemType[]
  lastUpdatedText?: string
  customButton: textButtonCustom
  textContentBorderActive?: boolean
}

export type TextListItemType = {
  headerTitle: string
  headerDetailList: string[]
  isHtml?: boolean
}

export type textButtonCustom = {
  closeButton?: {
    title: string
  }
  acceptButton?: {
    title: string
  }
}

export const PrivacyPolicyTextList: textModalType = {
  title: 'PRIVACY',
  subTitle: 'プライバシーポリシー',
  prefaceText: `
    <div class="text">
      <div class="indent">
        本ポリシーは、仁Studio株式会社（以下「当社」）が運営する「天比登都 -glamping 凪音-」（以下「当施設」）における個人情報の取扱いについて定めるものです。<br />
        当施設をご利用いただくお客様の個人情報の重要性を認識し、その適切な保護が社会的責務であると考え、当施設において取得する個人情報については、個人情報の保護に関する法律その他の関連法令およびガイドラインを遵守し、適正に取り扱います。<br />
        なお、本ポリシーは、当施設に関連して提供される各種サービス（宿泊、予約、付帯サービス等）に適用されます。<br />
        当施設をご利用の際は、本ポリシーおよび当社プライバシーポリシーをあわせてご確認ください。
      </div>
    </div>
  `,
  textList: [
    {
      headerTitle: '1.個人情報の取得',
      headerDetailList: [
        `
        <div class="text">
          <div class="indent">本契約において、以下の用語はそれぞれ以下のように定義します。</div>
          <ol>
            <li>お客様から直接取得する場合<br />電話、書面(電磁的記録を含む)、名刺、口頭、インターネット(端末、ブラウザ、アプリに係る情報の取得を含む)等</li>
            <li>ご本人から正当な権限を授与された者からの取得<br />利用申込者、紹介者、旅行斡旋事業者、提携先およびパッケージ商品等の受付事業者等</li>
            <li>公開情報から取得する場合<br />インターネット、新聞、書物およびその他の刊行物等</li>
          </ol>
        </div>
        `,
      ],
    },
    {
      headerTitle: '2.個人情報の利用目的',
      headerDetailList: [
        `
        <div class="text">
          <div class="indent">
            当施設は、取得した個人情報を、取得の際に示した利用目的の範囲内で、業務の遂行上必要な限りにおいて利用します。<br />
            具体的には以下の目的のために利用します。
          </div>
          <ol>
            <li>宿泊・飲食・物品販売・その他付帯サービスの提供およびこれに関連する連絡のため</li>
            <li>お問い合わせ・ご依頼等への対応のため</li>
            <li>サービス改善・開発およびマーケティング分析のため</li>
            <li>ウェブサイトの適切な運用、セキュリティ確保および利用状況の分析のため</li>
            <li>防犯・防災のために設置した防犯カメラの管理・記録のため</li>
            <li>法令に基づく宿泊者名簿の作成、保存および管理のため</li>
            <li>上記利用目的に付随する業務のため</li>
            <li>上記以外でお客様の同意があった場合</li>
          </ol>
        </div>
        `,
      ],
    },
    {
      headerTitle: '3.個人情報の種類',
      headerDetailList: [
        `
        <div class="text">
          <div class="indent">
            当施設が取得・保存する個人情報には以下が含まれます。
          </div>
          <ol>
            <li>基本情報<br />氏名、住所、性別、生年月日、国籍、電子メールアドレス、電話番号等</li>
            <li>付加情報<br />勤務先情報等</li>
            <li>支払情報<br />クレジットカード情報、銀行口座情報等</li>
            <li>サービス利用情報<br />施設利用状況、商品購入状況等</li>
            <li>連絡内容<br />メール、フォーム入力内容、アンケート回答等</li>
            <li>セキュリティ関連情報<br />防犯カメラ映像等</li>
            <li>ウェブサイト利用情報<br />Cookie、IPアドレス、ブラウザ情報、アクセス日時等</li>
            <li>宿泊者名簿記載事項<br />氏名、住所、国籍、旅券番号、年齢、性別、連絡先等</li>
          </ol>
        </div>
        `,
      ],
    },
    {
      headerTitle: '4.宿泊サービス提供に必要な個人情報',
      headerDetailList: [
        `
        <div class="text">
          <div class="indent">
            当施設は、宿泊サービスを提供するために必要な範囲で個人情報の提供をお願いしております。<br />
            具体的には、予約・本人確認および法令に基づく宿泊者名簿の作成に必要となる情報（氏名、住所、連絡先、国籍、旅券情報等を含みます）をご提供いただきます。<br />
            これらの情報が提供されない場合、宿泊サービスを提供できない場合があります。
          </div>
        </div>
        `,
      ],
    },
    {
      headerTitle: '5.個人情報の管理',
      headerDetailList: [
        `
        <div class="text">
          <div class="indent">
            当施設は、個人情報を正確かつ最新の内容に保つよう努めるとともに、不正アクセス、漏えい、滅失、毀損等を防止するため、適切な安全管理措置を講じます。<br />
            また、個人情報保護体制について継続的な改善に努めます。
          </div>
        </div>
        `,
      ],
    },
    {
      headerTitle: '6.個人情報の開示・訂正等',
      headerDetailList: [
        `
        <div class="text">
          <div class="indent">
            当施設は、原則として本人からの請求に基づき、個人情報の開示、訂正、追加、削除、利用停止等に対応します。<br />
            ただし、以下の場合には全部または一部を開示しないことがあります。
          </div>
          <ol>
            <li>本人または第三者の権利利益を害するおそれがある場合</li>
            <li>当施設の業務の適正な実施に著しい支障を及ぼすおそれがある場合</li>
            <li>法令に違反することとなる場合</li>
          </ol>
        </div>
        `,
      ],
    },
    {
      headerTitle: '7.個人情報の第三者提供',
      headerDetailList: [
        `
        <div class="text">
          <div class="indent">
            当施設は、以下の場合を除き、個人情報を第三者に提供しません。
          </div>
          <ol>
            <li>本人の同意がある場合</li>
            <li>業務遂行上必要な範囲で業務委託先に提供する場合</li>
            <li>個人を識別できない統計情報として提供する場合</li>
            <li>事業承継（合併・会社分割・営業譲渡等）の場合</li>
            <li>法令に基づく開示要請がある場合</li>
            <li>人の生命、身体または財産の保護のために必要で同意取得が困難な場合</li>
          </ol>
        </div>
        `,
      ],
    },
    {
      headerTitle: '8.個人情報の保持期間',
      headerDetailList: [
        `
        <div class="text">
          <div class="indent">
            当施設は、個人情報を利用目的の達成に必要な期間に限り保有し、不要となった個人情報については、合理的な期間内に適切な方法で削除または匿名化します。
          </div>
        </div>
        `,
      ],
    },
    {
      headerTitle: '9.プライバシーポリシーの変更',
      headerDetailList: [
        `
        <div class="text">
          <div class="indent">
            本ポリシーは、法令の改正、社会情勢の変化その他必要に応じて予告なく変更することがあります。<br />
            変更後の内容は本ウェブサイトに掲載した時点で効力を生じるものとします。
          </div>
        </div>
        `,
      ],
    },
    {
      headerTitle: '10.個人情報保護に関するお問い合わせ先',
      headerDetailList: [
        `
        <div class="text">
          <div class="indent">
            ご意見、ご質問、情報の取り扱いに関するお問い合わせは、当施設のお問い合わせフォームよりご連絡ください。
          </div>
        </div>
        `,
      ],
    },
  ],
  customButton: { closeButton: { title: '閉じる' } },
}

export const getTermsOfUse = (locale: 'ja' | 'en') => {
  const fixTermsOfUse = TermsOfUse
  switch (locale) {
    case 'en':
      fixTermsOfUse.subTitle = 'Terms of Use'
      fixTermsOfUse.customButton = { closeButton: { title: 'Close' } }
      break;
    case "ja":
    default:
      fixTermsOfUse.subTitle = '利用規約'
      fixTermsOfUse.customButton = { closeButton: { title: '閉じる' } }
      break;
  }
  return fixTermsOfUse
}

export const TermsOfUse: textModalType = {
  title: 'TERMS',
  subTitle: '利用規約',
  prefaceText: `
    <div class="text">
      <div class="indent">
        本利用規約は、仁Studio株式会社（以下「当社」）が運営する「天比登都 -glamping 凪音-」（以下「当施設」）の利用条件を定めるものです。<br />
        当施設をご利用いただくすべてのお客様は、本規約に同意いただいたものとみなします。<br />
        本規約をお守りいただけない場合、当施設の利用をお断りし、または退去いただく場合があります。<br />
        また、当施設または第三者に損害が生じた場合には、その損害をご負担いただくことがあります。
      </div>
    </div>
  `,
  textList: [
    {
      headerTitle: '予約・宿泊契約について',
      headerDetailList: [
        `
        <div class="text">
          <div class="indent">本契約において、以下の用語はそれぞれ以下のように定義します。</div>
          <ol>
            <li>宿泊料金、利用条件等は予約時点で当施設が提示した内容によるものとします。</li>
            <li>予約内容に虚偽、誤記または不正が判明した場合、当施設は予約を取り消す場合があります。</li>
            <li>未成年者のみでの宿泊については、保護者の同意をお願いする場合があります。</li>
            <li>宿泊人数が申込人数を超える場合、追加料金をご請求する場合があります。</li>
            <li>当施設では、大音量を伴うイベント、パーティー、宴会等を主目的とした宿泊利用はお断りしております。</li>
          </ol>
          <div class="indent"></div>
        </div>
        `,
      ],
    },
    {
      headerTitle: 'キャンセル・営業中止について',
      headerDetailList: [
        `
        <div class="text">
          <ol>
            <li>台風、災害、悪天候その他安全上の理由により、当施設が営業困難と判断した場合、営業を中止する場合があります。</li>
            <li>天災、設備故障、保守点検その他やむを得ない事由により、施設利用の全部または一部を中断する場合があります。</li>
            <li>無断キャンセルがあった場合、今後のご利用をお断りする場合があります。</li>
          </ol>
        </div>
        `,
      ],
    },
    {
      headerTitle: '施設の利用について',
      headerDetailList: [
        `
        <div class="text">
          <ol>
            <li>チェックインは15時から18時まで、チェックアウトは10時までとします。到着時刻が遅れる際は、予めご連絡下さい。</li>
            <li>他のお客様がいる宿泊スペースには立ち入らないでください。</li>
            <li>22時から7時はサイレントタイムとし、大声での会話、音楽、騒音行為等は禁止します。他のお客様のご迷惑となる行為が確認された場合、当施設スタッフより注意または改善のお願いをさせていただく場合があります。なお、改善が見られない場合は、利用停止または退去いただく場合があります。</li>
            <li>当施設内への音響機器(楽器・スピーカー等)は持ち込みを禁止します。</li>
            <li>手持ち花火は、21時まで指定場所に限りご利用いただけます。ご利用後は必ず消火を確認してください。なお、打ち上げ花火、仕掛け花火、大きな音の出る花火等は禁止します。</li>
            <li>当施設内での球技、ドローン飛行、その他、他のお客様の迷惑となる行為は禁止します。</li>
            <li>共用スペースの占有、所持品の放置、従業員区域への立入り、無断営業行為、広告配布、署名活動等は禁止します。</li>
            <li>他のお客様に不安、不快感を与える服装、言動、撮影行為は禁止します。</li>
            <li>客室外の共用スペースにおいて、下着姿またはそれに類する過度に肌の露出が多い服装でのご利用はご遠慮ください。また、他のお客様が快適に過ごせるよう、状況に応じて適切な服装でのご利用をお願いする場合があります。</li>
            <li>営業目的での撮影、録音等を行う場合は事前に当施設の許可を必要とします。</li>
            <li>小さなお子様の単独行動はご遠慮ください。</li>
            <li>ペットの同伴は禁止します。ただし、別途定めがある場合および身体障害者補助犬法に基づく補助犬を除きます。</li>
            <li>ボール類、遊具その他のお持込み物について、他のお客様の迷惑または安全上支障があると当施設が判断した場合、ご利用をご遠慮いただくことがあります。<br />また、お持込み物の利用に起因して発生した事故、怪我、損害等について、当施設に故意または重大な過失がある場合を除き、責任を負いません。</li>
            <li>従業員への心付け等はご辞退しております。</li>
            <li>法令上の理由により、医薬品の提供は行っておりません。</li>
            <li>災害、悪天候、野生動物の出没その他安全上必要がある場合、当施設スタッフの指示に従い、避難その他必要な対応を行っていただきます。</li>
            <li>当施設は豊かな自然環境の中に位置するグランピング施設です。敷地内や周辺には昆虫、野生動物、草木等が存在し、天候や季節によって自然環境が変化する場合があります。安全管理には十分配慮しておりますが、自然環境の特性をご理解いただき、安全に十分ご配慮のうえご利用ください。</li>
          </ol>
        </div>
        `,
      ],
    },
    {
      headerTitle: '客室の利用について',
      headerDetailList: [
        `
        <div class="text">
          <ol>
            <li>客室内では、当施設の許可なく火気・キャンドル等を使用しないでください。</li>
            <li>客室内は禁煙です。喫煙は指定場所をご利用ください。なお、当施設内でたばこの販売はしておりません。</li>
            <li>指定の場所以外での喫煙が発覚し、施設に臭気付着、汚損、損傷等の被害が確認された場合には、設備・備品の交換にかかった全ての費用をお客様にお支払いただきます。</li>
            <li>消防用設備等に対するいたずら等、火災予防・防火に支障を及ぼす行為は禁止します。</li>
            <li>客室内のキッチンをご利用の際は、必ず換気を行ってください。換気が不十分な場合、火災報知設備が誤作動する可能性があります。</li>
            <li>備品の移動、改造、用途外利用は禁止します。</li>
            <li>備品等の破損、汚損が発生した場合、原状回復費用をご負担いただく場合があります。</li>
            <li>客室内の小物や備品を施設外へ持ち出すことは禁止します。</li>
            <li>お部屋から離れる際には安全のため、施錠をお願いします。</li>
            <li>鍵はチェックアウト時にご返却いただきます。鍵を紛失した場合、交換費用等をご負担いただきます。</li>
            <li>客室への来訪者の招き入れはご遠慮ください。</li>
            <li>暖房器具、炊飯器、電気コンロ等の消費電力の高い電気機器の持込み・使用は禁止します。</li>
            <li>生ゴミ等は適切に管理し、野生動物を誘引しないようご協力ください。</li>
            <li>香水の大量使用、お香、アロマ等強い香りを発する行為は禁止します。</li>
            <li>染髪、漂白等により設備を汚損する行為は禁止します。</li>
            <li>嘔吐、排せつ、出血等による著しい汚損が発生した場合、清掃費用等をご負担いただく場合があります。</li>
            <li>衛生管理その他必要がある場合、当施設スタッフが客室へ立ち入る場合があります。</li>
            <li>長期のご宿泊利用により、居住に関する法律上の権利が発生するものではないことをご了承ください。</li>
          </ol>
        </div>
        `,
      ],
    },
    {
      headerTitle: '食事・火気利用について',
      headerDetailList: [
        `
        <div class="text">
          <ol>
            <li>食材、飲料等の管理はお客様ご自身の責任で行ってください。</li>
            <li>食べ物や食べ残しを投棄することを一切禁止します。指定のゴミ箱をご利用ください。</li>
            <li>食材の保管は、必ず屋内での保管をお願いします。</li>
            <li>お持込みいただいた食品等に起因する食中毒・体調不良等について、当施設に故意または重大な過失がある場合を除き、責任を負いません。</li>
            <li>強い臭気を発する食材等の調理はご遠慮ください。</li>
            <li>食品等を他のお客様へ販売または譲渡する行為は禁止します。</li>
            <li>野生動物への餌やりは禁止します。</li>
            <li>BBQグリルのご利用後は、ガス栓を閉栓し、火が確実に消えていることをご確認ください。</li>
          </ol>
        </div>
        `,
      ],
    },
    {
      headerTitle: '貸出品・設備利用について',
      headerDetailList: [
        `
        <div class="text">
          <ol>
            <li>貸出品は先着順とし、数に限りがあります。</li>
            <li>タオル、備品等の持ち帰りは禁止です。チェックアウト後に発覚した場合は郵送・宅配での返却依頼または賠償金を申し受けます。</li>
            <li>当施設指定以外のBBQグリル等火気設備の持ち込みは禁止です。</li>
          </ol>
        </div>
        `,
      ],
    },
    {
      headerTitle: 'ゴミ処理について',
      headerDetailList: [
        `
        <div class="text">
          <ol>
            <li>ゴミは当施設指定の方法に従い、分別をお願いいたします。</li>
            <li>食べ残し、飲食物等を屋外へ放置しないでください。野生動物や害虫が寄り付く原因となります。</li>
            <li>発泡スチロール、大型梱包材その他当施設で処理が困難なゴミについては、お持ち帰りをお願いする場合があります。</li>
          </ol>
        </div>
        `,
      ],
    },
    {
      headerTitle: '駐車場について',
      headerDetailList: [
        `
        <div class="text">
          <ol>
            <li>駐車場は当施設利用者のみ利用可能です。</li>
            <li>駐車台数に限りがございますので、複数台でお越しの際は事前にご相談ください。</li>
            <li>駐車場内では徐行し、従業員または案内表示に従ってください。</li>
            <li>駐車場内で発生した事故、盗難、利用者間のトラブル等については、当施設に故意または重大な過失がある場合を除き責任を負いません。</li>
            <li>車内に貴重品を放置しないでください。</li>
            <li>従業員による車の代行移動はいたしかねますのでご了承ください。</li>
            <li>長期間放置された車両については、施設の判断により必要な対応を行う場合があります。</li>
          </ol>
        </div>
        `,
      ],
    },
    {
      headerTitle: '貴重品・所持品について',
      headerDetailList: [
        `
        <div class="text">
          <ol>
            <li>貴重品および高価品はお客様ご自身で管理してください。</li>
            <li>当施設内で発生した紛失、盗難等について、当施設に故意または重大な過失がある場合を除き、責任を負いません。</li>
            <li>遺失物の保管期間は、法令に定めがある場合を除き、一定期間経過後に処分する場合があります。</li>
          </ol>
        </div>
        `,
      ],
    },
    {
      headerTitle: '料金・精算について',
      headerDetailList: [
        `
        <div class="text">
          <ol>
            <li>当施設外で発生した費用について、立替払いや宿泊料金との合算精算は行っておりません。</li>
            <li>当施設が必要と判断した場合、滞在中であっても料金のご精算をお願いする場合があります。</li>
            <li>料金のお支払いは、当施設が定める方法により行っていただきます。</li>
            <li>宿泊プランの変更または宿泊期間の延長を希望される場合は、事前にお申し出ください。なお、延長利用については新たな宿泊契約として取り扱う場合があります。</li>
          </ol>
        </div>
        `,
      ],
    },
    {
      headerTitle: '利用拒否・退去について',
      headerDetailList: [
        `
        <div class="text">
          <ol>
            <li>当施設は、次のいずれかに該当する場合、宿泊または施設利用をお断りし、または利用中であっても退去いただく場合があります。</li>
          </ol>
          <ul class="indent">
            <li>本規約に違反した場合</li>
            <li>他のお客様または従業員に迷惑・危険を及ぼすおそれがある場合</li>
            <li>法令または公序良俗に反する行為が認められた場合</li>
            <li>暴力団その他反社会的勢力に該当すると認められる場合</li>
            <li>当施設の安全な運営を妨げる行為があった場合</li>
          </ul>
        </div>
        <div class="indent">
          なお、この場合、未利用分を含め返金には応じかねる場合があります。
        </div>
        `,
      ],
    },
    {
      headerTitle: '免責事項',
      headerDetailList: [
        `
        <div class="text">
          <ol>
            <li>当施設は、自然環境に起因する虫、動物、風雨、気温変化等について責任を負いません。</li>
            <li>当施設は自然環境に囲まれた施設であり、敷地内には草木、昆虫、野生動物等が存在します。お客様ご自身で安全にご配慮いただき、接触等には十分ご注意ください。これら自然環境に起因して生じた事故、怪我、アレルギー等について、当施設に故意または重大な過失がある場合を除き、責任を負いません。</li>
            <li>お客様ご自身の不注意による事故、怪我、盗難、紛失等について、当施設に故意または重大な過失がある場合を除き、責任を負いません。</li>
            <li>通信設備、設備故障その他不可抗力により発生した損害について、当施設は責任を負いません。</li>
            <li>食品の持込みに起因する食中毒等について、当施設に故意または重大な過失がある場合を除き、責任を負いません。</li>
          </ol>
        </div>
        `,
      ],
    },
    {
      headerTitle: 'その他',
      headerDetailList: [
        `
        <div class="text">
          <ol>
            <li>以下の内容については、宿泊約款の定めのとおりとします。</li>
          </ol>
          <ul class="indent">
            <li>インターネット通信の利用</li>
            <li>禁止事項および損害賠償</li>
          </ul>
        </div>
        `,
      ],
    },
    {
      headerTitle: '規約の変更',
      headerDetailList: [
        `
        <div class="text">
          <ol>
            <li>本規約は、法令改正、社会情勢の変化その他必要に応じて変更する場合があります。</li>
            <li>変更後の内容は、当施設ウェブサイト等へ掲載した時点で効力を生じるものとします。</li>
          </ol>
        </div>
        `,
      ],
    },
    {
      headerTitle: 'お問い合わせ',
      headerDetailList: [
        `
        <div class="text">
          <ol>
            <li>本規約に関するお問い合わせは、当施設のお問い合わせフォームよりご連絡ください。</li>
          </ol>
        </div>
        `,
      ],
    },
  ],
  customButton: { closeButton: { title: '閉じる' } },
}
